import { render, staticRenderFns } from "./CustomerInternationalAccount.vue?vue&type=template&id=b1e0e818"
import script from "./CustomerInternationalAccount.vue?vue&type=script&lang=js"
export * from "./CustomerInternationalAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports